import { Lab } from '../../../contracts/lab/lab.model';
import { LabInstrument } from '../../../contracts/instrument/lab-instrument.model';
import { LabTestData } from '../../../contracts/lab-test/legacy/test-data.model';
import { StudyTestTeaConfigs } from '../../../contracts/common/study-test-tea-config.model';

export interface ILabState {
    currentLab: Lab;
    currentLabInstruments: LabInstrument[];
    labs: Lab[];
    studyTestTeaConfigs: StudyTestTeaConfigs;
}

const initialState: ILabState = {
    currentLab: null,
    currentLabInstruments: [],
    labs: [],
    studyTestTeaConfigs: null
};

export default initialState;



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/lab/ILabState.ts